var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns" }, [
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-dropdown",
          { ref: "filtersDropdown", staticClass: "contract__filters-dropdown" },
          [
            _c(
              "div",
              {
                staticClass: "field",
                attrs: { slot: "trigger" },
                slot: "trigger"
              },
              [
                _c(
                  "div",
                  { staticClass: "control has-icons-left has-icons-right" },
                  [
                    _c("sc-icon", {
                      staticClass: "is-left",
                      attrs: { icon: "table" }
                    }),
                    _vm._v(" "),
                    _c("button", {
                      staticClass:
                        "button input has-icons-left has-text-left is-fullwidth",
                      attrs: { type: "button" },
                      domProps: { innerHTML: _vm._s(_vm.labelSelect) }
                    }),
                    _vm._v(" "),
                    _c("sc-icon", {
                      staticClass: "is-right",
                      attrs: { icon: "angle-down" }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "sc-dropdown-item",
              { attrs: { custom: "", paddingless: "" } },
              [
                _c(
                  "sc-card",
                  { staticClass: "contract__card" },
                  [
                    _c(
                      "template",
                      { attrs: { slot: "body" }, slot: "body" },
                      _vm._l(_vm.listContractFilter, function(ec) {
                        return _c(
                          "div",
                          { staticClass: "contract__filters-dropdown-content" },
                          [
                            ec.list.length
                              ? _c("sc-field", { attrs: { label: ec.name } })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(ec.list, function(lc, i) {
                              return _c(
                                "sc-field",
                                { key: i },
                                [
                                  _c(
                                    "sc-checkbox",
                                    {
                                      attrs: {
                                        size: "is-small",
                                        "native-value": lc
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.toggleContract(
                                            $event,
                                            _vm.contract.id
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.add_contracts,
                                        callback: function($$v) {
                                          _vm.add_contracts = $$v
                                        },
                                        expression: "add_contracts"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  #ID " +
                                          _vm._s(lc.id) +
                                          " - " +
                                          _vm._s(lc.file_name) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      })
                    ),
                    _vm._v(" "),
                    _c(
                      "template",
                      { attrs: { slot: "footer" }, slot: "footer" },
                      [
                        _c(
                          "div",
                          { staticClass: "contract__filters-dropdown-footer" },
                          [
                            _c("sc-button", {
                              ref: "filtersDropdown",
                              attrs: { theme: "default", text: "Fechar" },
                              on: { click: _vm.closeFilters }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  2
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3695fec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3695fec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-contract/ScContract.vue
// module id = null
// module chunks = 